//Generated File 
export const Approved = `Approved`;
export const InProgress = `InProgress`;
export const Rejected = `Rejected`;
export const Returned = `Returned`;
export const Revoked = `Revoked`;
